var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBellProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3571_5842)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.12917 20C7.10833 20 6.1625 19.3292 5.85833 18.3C5.7625 17.9708 5.95 17.6208 6.28333 17.525C6.6125 17.4292 6.9625 17.6167 7.05833 17.95C7.23333 18.5417 7.85417 18.8792 8.44167 18.7042C8.80833 18.5958 9.0875 18.3167 9.19583 17.95C9.29167 17.6208 9.64167 17.4292 9.97083 17.525C10.3 17.6208 10.4917 17.9708 10.3958 18.3C10.1667 19.075 9.57083 19.675 8.79167 19.9042C8.57083 19.9708 8.34583 20 8.125 20H8.12917Z",
    fill: "#194142"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.125 3.125C7.77917 3.125 7.5 2.84583 7.5 2.5V0.625C7.5 0.279167 7.77917 0 8.125 0C8.47083 0 8.75 0.279167 8.75 0.625V2.5C8.75 2.84583 8.47083 3.125 8.125 3.125Z",
    fill: "#194142"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.625 16.25H0.624986C0.387486 16.25 0.166653 16.1125 0.0624864 15.9C-0.0416802 15.6833 -0.0166802 15.4292 0.13332 15.2417C0.137486 15.2333 1.24999 13.6583 1.24999 8.75C1.24999 4.95833 4.33332 1.875 8.12499 1.875C11.9167 1.875 15 4.95833 15 8.75C15 13.9958 16.0083 15.1292 16.0167 15.1375C16.225 15.3042 16.3042 15.5833 16.2167 15.8333C16.1292 16.0833 15.8917 16.25 15.625 16.25V16.25ZM1.63332 15H14.5542C14.1583 13.9917 13.75 12.1292 13.75 8.75C13.75 5.65 11.225 3.125 8.12499 3.125C5.02499 3.125 2.49999 5.65 2.49999 8.75C2.49999 12.0417 2.02915 13.9667 1.63332 15Z",
    fill: "#194142"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3571_5842"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.25,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellProfile);
export default __webpack_public_path__ + "static/media/bell_profile.fc192effbb039733daea842759c710bb.svg";
export { ForwardRef as ReactComponent };